import script from "./ReportPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPanel.vue?vue&type=script&setup=true&lang=js"

import "./ReportPanel.vue?vue&type=style&index=0&id=378beeb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378beeb2"]])

export default __exports__